import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/')({
    // Only redirects: `/settings/organization` checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    beforeLoad: () => {
        throw redirect({ to: '/settings/organization' });
    },
});
